import { jsxs as C, jsx as l } from "react/jsx-runtime";
const d = ({}) => /* @__PURE__ */ C(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
          fill: "#F3F3FD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M67.4249 71.6648L51.179 59.7987C50.4763 59.2854 49.5224 59.2854 48.8197 59.7987L32.5738 71.6648C31.7809 72.2439 30.666 71.6776 30.666 70.6958V28.6667C30.666 28.2985 30.9645 28 31.3327 28H68.666C69.0342 28 69.3327 28.2985 69.3327 28.6667V70.6958C69.3327 71.6776 68.2178 72.2439 67.4249 71.6648ZM43.666 41.9997C43.666 38.5019 46.5015 35.6663 49.9993 35.6663C53.4972 35.6663 56.3327 38.5019 56.3327 41.9997C56.3327 45.4975 53.4972 48.333 49.9993 48.333C46.5015 48.333 43.666 45.4975 43.666 41.9997Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M31.3327 26C29.8599 26 28.666 27.1939 28.666 28.6667V42H44.666C44.666 39.0545 47.0538 36.6667 49.9993 36.6667C52.9449 36.6667 55.3327 39.0545 55.3327 42H71.3327V28.6667C71.3327 27.1939 70.1388 26 68.666 26H31.3327Z",
          fill: "#676DFD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M51.179 59.7987L67.4249 71.6648C68.2178 72.2439 69.3327 71.6776 69.3327 70.6958V28.6667C69.3327 28.2985 69.0342 28 68.666 28H31.3327C30.9645 28 30.666 28.2985 30.666 28.6667V70.6958C30.666 71.6776 31.7809 72.2439 32.5738 71.6648L48.8197 59.7987C49.5224 59.2854 50.4763 59.2854 51.179 59.7987ZM66.2452 73.2799C68.3596 74.8242 71.3327 73.3141 71.3327 70.6958V28.6667C71.3327 27.1939 70.1388 26 68.666 26H31.3327C29.8599 26 28.666 27.1939 28.666 28.6667V70.6958C28.666 73.3141 31.6391 74.8242 33.7535 73.2799L49.9993 61.4137L66.2452 73.2799Z",
          fill: "#49565D"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M49.9993 37.6664C47.6061 37.6664 45.666 39.6065 45.666 41.9997C45.666 44.3929 47.6061 46.333 49.9993 46.333C52.3926 46.333 54.3327 44.3929 54.3327 41.9997C54.3327 39.6065 52.3926 37.6664 49.9993 37.6664ZM43.666 41.9997C43.666 38.5019 46.5015 35.6664 49.9993 35.6664C53.4972 35.6664 56.3327 38.5019 56.3327 41.9997C56.3327 45.4975 53.4972 48.333 49.9993 48.333C46.5015 48.333 43.666 45.4975 43.666 41.9997Z",
          fill: "#49565D"
        }
      )
    ]
  }
);
export {
  d as TagIllustration
};
//# sourceMappingURL=index.es503.js.map
